import { makeStyles } from "@material-ui/core";
import { whiteGrey, white } from "../../constants/colors";

const useStyles = makeStyles(({ breakpoints: { down } }) => ({
  hotelCardStyles: {
    backgroundColor: whiteGrey,
    padding: "60px",
    borderRadius: "20px",
    marginBottom: "20px",
    [down("sm")]: {
      padding: "20px 50px",
    },
    [down("xs")]: {
      padding: "18px",
      borderRadius: "10px",
    },
  },
  label: {
    fontSize: "11px",
    fontFamily: "sbcBold",
    lineHeight: 1.5,
    letterSpacing: "0.09em",
    textTransform: "uppercase",
    marginBottom: "8px",
  },
  accomodationDescription: {
    "&:first-of-type": {
      width: "40%",
      [down("xs")]: {
        width: "100%",
        marginBottom: "12px",
      },
    },
    width: "15%",
    [down("xs")]: {
      width: "50%",
      marginBottom: "12px",
    },
  },
  accomodationImg: {
    borderRadius: "10px",
    backgroundColor: white,
    height: "180px",
  },
  img: {
    height: "100%",
    width: "100%",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  },
}));

export default useStyles;
